var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilledActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9C7 8.44772 7.21102 8 8 8H26C26.789 8 27 8.44772 27 9C27 9.55228 26.789 10 26 10H8C7.21102 10 7 9.55228 7 9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 21C7 20.4477 7.21102 20 8 20H26C26.789 20 27 20.4477 27 21C27 21.5523 26.789 22 26 22H8C7.21102 22 7 21.5523 7 21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 15C7 14.4477 7.21102 14 8 14H26C26.789 14 27 14.4477 27 15C27 15.5523 26.789 16 26 16H8C7.21102 16 7 15.5523 7 15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21C3 21.5523 2.55228 22 2 22C1.44772 22 1 21.5523 1 21C1 20.4477 1.44772 20 2 20C2.55228 20 3 20.4477 3 21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15C3 15.5523 2.55228 16 2 16C1.44772 16 1 15.5523 1 15C1 14.4477 1.44772 14 2 14C2.55228 14 3 14.4477 3 15Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9C3 9.55228 2.55228 10 2 10C1.44772 10 1 9.55228 1 9C1 8.44772 1.44772 8 2 8C2.55228 8 3 8.44772 3 9Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledActive);
export default __webpack_public_path__ + "static/media/filled-active.5eac4b28e566c5df90c864cfb785385d.svg";
export { ForwardRef as ReactComponent };